import { createFileRoute } from '@tanstack/react-router';

import { getSupportTicketDetailQuery } from '@/_containers/support/shared/apis';
import Loading from '@/_pages/support/profile/loading';

export const Route = createFileRoute('/_private/support/$ticket_id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getSupportTicketDetailQuery(opts.params.ticket_id)),
  pendingComponent: Loading,
});
